import { toast } from 'react-toastify'
import * as types from './types'
import * as integration from '../../../integration'

export const receive = (value) => ({
  type: types.RECEIVE_LIST,
  payload: value
})

export const fetch = (payload = true) => ({
  type: types.FETCH_LIST,
  payload
})

export const clearSupervised = () => ({
  type: types.CLEAR_LIST
})

export const getAllSupervised = (params) => async (dispatch) => {
  dispatch(fetch())

  try {
    const { data, metadata } =
      await integration.resources.supervised.requests.getAll(params)

    dispatch(
      receive({
        data,
        pagination: metadata.pagination
      })
    )
  } catch ({ error }) {
    if (error.status !== 403 && error.errors) {
      error.errors.map((message) => {
        toast.error(message)
      })
    }
    dispatch(fetch(false))
  }
}

export const fetchDetail = (payload = true) => ({
  type: types.FETCH_DETAIL,
  payload
})

export const receiveDetail = (payload) => ({
  type: types.RECEIVE_DETAIL,
  payload
})

export const clearDetail = () => ({
  type: types.CLEAR_DETAIL
})

export const getDetail = (stdCode) => async (dispatch) => {
  dispatch(fetchDetail())

  try {
    const { data } = await integration.resources.supervised.requests.getDetail(
      stdCode
    )

    dispatch(receiveDetail(data))
  } catch (error) {
    if (error.status !== 403 && error.errors) {
      error.errors.map((message) => {
        toast.error(message)
      })
    }
  } finally {
    dispatch(fetchDetail(false))
  }
}

export const fetchWalletSupervised = (payload = true) => ({
  type: types.FETCH_WALLET_SUPERVISED,
  payload
})

export const receiveWalletSupervised = (payload) => ({
  type: types.RECEIVE_WALLET_SUPERVISED,
  payload
})

export const clearWalletSupervised = () => ({
  type: types.CLEAR_WALLET_SUPERVISED
})

export const getWalletSupervised =
  (stdCode, params) => async (dispatch, getState) => {
    dispatch(fetchWalletSupervised())

    try {
      const oldData = getState().supervisedReducer.wallets.list

      const {
        data,
        metadata: { pagination }
      } = await integration.resources.supervised.requests.getWalletSupervised(
        stdCode,
        params
      )

      let newdata = data

      if (pagination.currentPage > 1) {
        newdata = [...oldData, ...data]
      }

      dispatch(receiveWalletSupervised({ data: newdata, pagination }))
    } catch (error) {
      if (error.status !== 403 && error.errors) {
        error.errors.map((message) => {
          toast.error(message)
        })
      }
      dispatch(receiveWalletSupervised([]))
    } finally {
      dispatch(fetchWalletSupervised(false))
    }
  }
